export default function hero() {

  $('.hero-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 2800,
    slide: 'div',
    autoplay: true,
    autoplaySpeed: 2500,
  });

}



// WEBPACK FOOTER //
// ./scripts/modules/hero.js